module.exports = __webpack_public_path__ + "static/img/chanpin.05fe59d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanpin.png
// module id = lWW7
// module chunks = 1